import React from 'react';
import { EcosystemStats } from './components/EcosystemStats';
import { ZeroStats } from './components/ZeroStats';
export const SystemStats = () => (React.createElement(React.Fragment, null,
    React.createElement(ZeroStats, { className: "mb-8", dataAttribute: "zero-statistics" }),
    React.createElement(EcosystemStats, { dataAttribute: "ecosystem-statistics" })));
